import { range } from '~/utils'

import { PlusMinusConfig } from './types'

const plusMinusConfig: { [key: string]: PlusMinusConfig } = {
  '1': {
    unknownVariable: 3,
    sign: ['+', '-'],
    numRange: range(10 - 1).map((elem) => elem + 1),
    minResult: 1,
    maxResult: 17,
    resetHistory: 10,
  },
  '2': {
    unknownVariable: 3,
    sign: ['+', '-'],
    numRange: range(25 - 6).map((elem) => elem + 6),
    minResult: 6,
    maxResult: 42,
    resetHistory: 20,
  },
  '3': {
    unknownVariable: 4,
    sign: ['+', '-'],
    numRange: range(25 - 1).map((elem) => elem + 1),
    minResult: 2,
    maxResult: 71,
    resetHistory: 30,
  },
  '4': {
    unknownVariable: 5,
    sign: ['+', '-'],
    numRange: range(25 - 1).map((elem) => elem + 1),
    minResult: 3,
    maxResult: 95,
    resetHistory: 40,
  },
}
/**
 *
 * @param difficultyLevel
 * @returns configuration object based on difficulty level
 */
export function getRangesByDifficulty(difficultyLevel: number): PlusMinusConfig {
  return plusMinusConfig[difficultyLevel] || new Error(`Invalid difficulty level: ${difficultyLevel}`)
}
